// extracted by mini-css-extract-plugin
module.exports = {"popupNameTrigger":"Network_popupNameTrigger_3SNDqKG","popupNameContent":"Network_popupNameContent_hN-VbcO"};